import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// import {Manager, Reference, Popper} from "react-popper";
import {NavLink}from 'react-router-dom';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Hidden from "@material-ui/core/Hidden";

// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";
import {dashboardRouter} from "../../util/globalHelper"

// core components
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import AutoCompletePatientSearchHeader from "components/Search/AutoCompletePatientSearchHeader.jsx";

import headerLinksStyle from "assets/jss/material-dashboard-pro-react/components/headerLinksStyle";

class HeaderLinks extends React.Component {
    state = {
        open: false,
        patientId: ""
    };
    handleClick = () => {
        this.setState({open: !this.state.open});
    };
    handleClose = () => {
        this.setState({open: false});
    };
    getSuggestionValue = (suggestion) => {
        this.setState({
            patientId: suggestion._id,

        });
        return suggestion.user_id.name
    };

    render() {
        const {classes, rtlActive} = this.props;
        const {open} = this.state;
        const searchButton =
            classes.top +
            " " +
            classes.searchButton +
            " " +
            classNames({
                [classes.searchRTL]: rtlActive
            });
        const dropdownItem =
            classes.dropdownItem +
            " " +
            classNames({
                [classes.dropdownItemRTL]: rtlActive
            });
        const wrapper = classNames({
            [classes.wrapperRTL]: rtlActive
        });
        const managerClasses = classNames({
            [classes.managerClasses]: true
        });
        return (
            <div className={wrapper} id="header">
                <AutoCompletePatientSearchHeader
                    className={classes.searchInput}
                    getSuggestionValue={this.getSuggestionValue}/>
                {/*<CustomInput*/}
                {/*    rtlActive={rtlActive}*/}
                {/*    formControlProps={{*/}
                {/*        className: classes.top + " " + classes.search*/}
                {/*    }}*/}
                {/*    inputProps={{*/}
                {/*        placeholder: rtlActive ? "بحث" : "Search Patient",*/}
                {/*        inputProps: {*/}
                {/*            "aria-label": rtlActive ? "بحث" : "Search Patient",*/}
                {/*            className: classes.searchInput*/}
                {/*        }*/}
                {/*    }}*/}
                {/*/>*/}
                {/*<Button*/}
                {/*    color="white"*/}
                {/*    aria-label="edit"*/}
                {/*    justIcon*/}
                {/*    round*/}
                {/*    className={searchButton}*/}
                {/*>*/}
                {/*    <Search*/}
                {/*        className={classes.headerLinksSvg + " " + classes.searchIcon}*/}
                {/*    />*/}
                {/*</Button>*/}
                {/*<Button*/}
                {/*color="transparent"*/}
                {/*simple*/}
                {/*aria-label="Dashboard"*/}
                {/*justIcon*/}
                {/*className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}*/}
                {/*muiClasses={{*/}
                {/*label: rtlActive ? classes.labelRTL : ""*/}
                {/*}}*/}
                {/*>*/}
                {/*<Dashboard*/}
                {/*className={*/}
                {/*classes.headerLinksSvg +*/}
                {/*" " +*/}
                {/*(rtlActive*/}
                {/*? classes.links + " " + classes.linksRTL*/}
                {/*: classes.links)*/}
                {/*}*/}
                {/*/>*/}
                {/*<Hidden mdUp>*/}
                {/*<span className={classes.linkText}>*/}
                {/*{rtlActive ? "لوحة القيادة" : "Dashboard"}*/}
                {/*</span>*/}
                {/*</Hidden>*/}
                {/*</Button>*/}

                        <NavLink to={dashboardRouter("/appointment/requests")}>
                            <Button
                                color="transparent"
                                justIcon
                                aria-label="Notifications"
                                aria-owns={open ? "menu-list" : null}
                                aria-haspopup="true"
                                // onClick={this.handleClick}
                                className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
                                muiClasses={{
                                    label: rtlActive ? classes.labelRTL : ""
                                }}
                            >
                                <Notifications
                                    className={
                                        classes.headerLinksSvg +
                                        " " +
                                        (rtlActive
                                            ? classes.links + " " + classes.linksRTL
                                            : classes.links)
                                    }
                                />
                                <span
                                    className={classes.notifications}>{localStorage.getItem("requestList") ? JSON.parse(localStorage.getItem("requestList")).length : 0}</span>
                                <Hidden mdUp>
                <span onClick={this.handleClick} className={classes.linkText}>
                  {rtlActive ? "إعلام" : "Notification"}
                </span>
                                </Hidden>
                            </Button>
                        </NavLink>

                <NavLink to={dashboardRouter("/myprofile")}>
                    <Button
                        color="transparent"
                        aria-label="Person"
                        justIcon
                        className={rtlActive ? classes.buttonLinkRTL : classes.buttonLink}
                        muiClasses={{
                            label: rtlActive ? classes.labelRTL : ""
                        }}
                    >
                        <Person
                            className={
                                classes.headerLinksSvg +
                                " " +
                                (rtlActive
                                    ? classes.links + " " + classes.linksRTL
                                    : classes.links)
                            }
                            color="info"
                        />
                        <Hidden mdUp>
                            <span className={classes.linkText}>
                              {"Profile"}
                            </span>
                        </Hidden>
                    </Button>
                </NavLink>
            </div>
        );
    }
}

HeaderLinks.propTypes = {
    classes: PropTypes.object.isRequired,
    rtlActive: PropTypes.bool
};

export default withStyles(headerLinksStyle)(HeaderLinks);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderLinks.jsx